/**
 * Drop timeline context from audit log rows.
 */

import { extractSmswiserKillContextFromAudit } from '@/features/siem/utils/extract-smswiser-kill-context';

import type { DropTimelineContext } from './types';
import {
  mergeCtx,
  parseDropId,
  parseTimelineUniqueId,
} from './siem-resolve.util';

function asRecord(v: unknown): Record<string, unknown> | null {
  return v != null && typeof v === 'object' && !Array.isArray(v)
    ? (v as Record<string, unknown>)
    : null;
}

export function extractDropTimelineContextFromAudit(
  action: string,
  requestBody: Record<string, unknown> | null | undefined,
  entityId?: string | null,
  entityName?: string | null,
): DropTimelineContext {
  if (action === 'drop.create') {
    const body = asRecord(requestBody ?? null);
    const fromBody =
      parseTimelineUniqueId(body?.uniqueId) ??
      parseTimelineUniqueId(body?.unique_id);
    const fromEntity =
      typeof entityId === 'string' ? parseTimelineUniqueId(entityId) : undefined;
    const uniqueId = fromBody ?? fromEntity;
    const wiserDropId =
      parseDropId(body?.dropId) ?? parseDropId(body?.id);
    return {
      ...(uniqueId != null ? { uniqueId } : {}),
      ...(wiserDropId != null ? { wiserDropId } : {}),
    };
  }

  if (action === 'drop.delete') {
    const kill = extractSmswiserKillContextFromAudit(
      action,
      requestBody,
      entityId,
    );
    const nameUid =
      typeof entityName === 'string'
        ? parseTimelineUniqueId(entityName)
        : undefined;
    const killNorm: DropTimelineContext = {
      ...(kill.uniqueId != null ? { uniqueId: parseTimelineUniqueId(kill.uniqueId) } : {}),
      ...(kill.wiserDropId != null ? { wiserDropId: kill.wiserDropId } : {}),
    };
    return mergeCtx(killNorm, nameUid != null ? { uniqueId: nameUid } : {});
  }

  return {};
}
